import { render, staticRenderFns } from "./thresholdEdit.vue?vue&type=template&id=8b5a718a&scoped=true&"
import script from "./thresholdEdit.vue?vue&type=script&lang=js&"
export * from "./thresholdEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5a718a",
  null
  
)

export default component.exports